import { isBrowserIe, isBrouserEdge, isBrowserIOSSafari } from './BrowserJudgment';

/**
 * 画面トップへスクロール
 */
export const scrollTop = () => {
  const logo = document.getElementsByClassName('scroll-top')[0];

  logo?.addEventListener('click', event => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  });
};
scrollTop();

/**
 * ナビゲーションバーを考慮し、対象要素までスクロールする
 *
 * @param element 対象要素
 * @param option 対象要素 + α の移動幅
 */
export const scrollTargetElement = (element: HTMLElement | null, option: number) => {
  if (element === null) {
    return;
  }
  // navbarの高さを算出する
  const header = document.getElementById('navbar');
  const header_height = header !== null && typeof header !== 'undefined' ? header.clientHeight : 0;

  // ClientRectを取得する
  const client_rect = element?.getBoundingClientRect();
  // 要素の高さを取得する
  const element_height = typeof client_rect !== 'undefined' ? client_rect.height : 0;
  // 座標を算出する
  const pos_y = typeof client_rect !== 'undefined' ? client_rect.top + window.pageYOffset : 0;

  if (isBrowserIe()) {
    // IE
    // NOTE IEはnavbarが追従してこないため、navbarの高さを考慮しない
    scrollTo(0, pos_y + element_height + option);
  } else if (isBrouserEdge() || isBrowserIOSSafari()) {
    // Edge(従来版), iOS版Safari
    scrollTo(0, pos_y + element_height - header_height + option);
  } else {
    scrollTo({
      top: pos_y + element_height - header_height + option,
      left: 0,
      behavior: 'smooth',
    });
  }
};

/**
 * 画面トップへスクロール
 */
export const scrollPageTop = () => {
  window.scrollTo({ top: 0, left: 0 });
};
